import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const highlights = ['6 Complete Volumes', '5 Strategic Bonuses', '300+ Ready-to-Use Sessions', '120+ Visual Reference Cards', 'All Age & Skill Levels'];
const assurances = [{
  icon: LockIcon,
  label: 'Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export function Hero() {
  return <header className="bg-noir" data-id="element-119" data-mp="xbpch3rchwdz">
      <div className="mx-auto max-w-shell px-5 pb-10 pt-12 sm:px-6 sm:pb-14 sm:pt-16" data-id="element-120" data-mp="x8b7rov7lb3d">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-3xl text-center" data-id="element-121" data-mp="s9ghk1uwwk98">
          <div className="flex items-center justify-center gap-3" data-id="element-122" data-mp="382fhvvzgliim">
            <span className="h-px w-8 bg-gold-dark" aria-hidden="true" data-id="element-123" data-mp="3814brpijjyoc" />
            <p className="text-[10px] font-semibold uppercase tracking-label text-gold sm:text-[11px]" data-id="element-124" data-mp="3j9u1d0dmvqmc">
              The Jazz Teacher&rsquo;s Arsenal&trade;
            </p>
            <span className="h-px w-8 bg-gold-dark" aria-hidden="true" data-id="element-125" data-mp="39aur5dd7zmx8" />
          </div>

          <h1 className="mt-5 font-display text-[2rem] font-semibold leading-[1.08] text-gold-light sm:text-5xl lg:text-6xl" data-id="element-126" data-mp="3e960zo3ilxfg">
            Plan your entire year of jazz guitar lessons in less than{' '}
            <span className="text-gold" data-id="element-127" data-mp="358howyxom757">five minutes</span>.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-paper-300 sm:text-lg" data-id="element-128" data-mp="35akni7cwh8lj">
            The definitive set of 6 volumes plus 5 strategic bonuses. 300+ ready-to-teach sessions,
            120+ visual reference cards, and every tool you need to evaluate student progress
            &mdash; already prepared for you.
          </p>
        </motion.div>

        <img src="https://cdn.magicpatterns.com/uploads/vFchDyybp1gA7zUWkdrNdP/ChatGPT_Image_25_ago_2026,_12_38_39_p.m..png" alt="The complete Jazz Teacher's Arsenal: six workbooks, the course on desktop, tablet and phone" className="mx-auto mt-8 w-full max-w-4xl sm:mt-10" data-id="element-129" data-mp="2lk8qw89gj6xs" />

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2 border-y border-wood-dark py-4 sm:gap-x-6 sm:gap-y-3 sm:py-5" data-id="element-130" data-mp="ia5jsznr2lv8">
          {highlights.map(item => <li key={item} className="text-[10px] font-semibold uppercase tracking-label text-paper-400 sm:text-[11px]" data-id="element-131" data-mp="1ayt8l57pjtdj">
              {item}
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center gap-5" data-id="element-132" data-mp="x14kzpm9a84s">
          <CtaButton size="lg" tone="gold" data-id="element-133" data-mp="x0uy4awich3b">
            Get the Arsenal now
          </CtaButton>
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-134" data-mp="3lu9w2xv49s9n">
            {assurances.map(({
            icon: Icon,
            label
          }) => <span key={label} className="flex items-center gap-2 text-xs text-paper-400" data-id="element-135" data-mp="1x9b0knlp8d68">
                <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-136" data-mp="21awco6qesnfd" />
                {label}
              </span>)}
          </div>
        </div>
      </div>
    </header>;
}